import {Box, Container} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useRef} from 'react'
import {createPortal} from 'react-dom'
import {useHeader} from '../../../hooks/use-header'
import useIntersectionObserver from '../../../hooks/use-intersection-observer'
import {css, Global} from '@emotion/react'

const PlpSubnavigation = ({children, filtersRef}) => {
    const {headerWrapper} = useHeader()
    // keep track of the height of the subnavigation - initial value as per design
    // exposed as css var --subnavigation-height at the :root level for use in other components
    const heightRef = useRef(105)

    // detect when filters start to go out of view and display the sticky filters
    const [, hideStickyFilters] = useIntersectionObserver(
        {
            useOnce: false,
            // the billion px bottom margin is to disable the observer from firing when the filters are bellow the fold
            // the horizontal margin is to prevent triggering from horizontal overflow - on android for example
            rootMargin: '-1px 1000000000px 1000000000px 1000000000px',
            // needed to prevent round off error on edge when set to 1
            threshold: 0.98,
            // we expect initially to be in view
            initialInView: true
        },
        filtersRef
    )

    if (!headerWrapper) {
        return null
    }

    return createPortal(
        <Box
            // update the component height on render when it's visible
            ref={(e) => {
                if (e?.clientHeight) {
                    heightRef.current = e.clientHeight
                }
            }}
            boxShadow="bottom"
            display={hideStickyFilters ? 'none' : 'block'}
        >
            {/* expose the component height as css var - currently used for top positioned toasts */}
            <Global
                styles={css`
                    :root {
                        --dynamic-subnavigation-height: ${!hideStickyFilters
                            ? heightRef.current
                            : 0}px;
                    }
                `}
            />
            <Container layerStyle="page" variant="no-padding">
                {children}
            </Container>
        </Box>,
        headerWrapper
    )
}

PlpSubnavigation.propTypes = {
    children: PropTypes.any,
    filtersRef: PropTypes.object
}

export default PlpSubnavigation
